/**
 * useAgencyConfig — hook che espone la config pubblica dell'agenzia (SSOT).
 *
 * Fetch da `/api/public/agency-config` (statica lato backend, cache in-memory).
 * Cache module-level per evitare fetch multipli tra componenti.
 * FIX 4 (v1.54.0.0) — abilita rimozione hardcode RUI da Footer/ChiSiamo.
 */
import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _cache = null;
let _inflight = null;

async function _fetchOnce() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = axios.get(`${API}/public/agency-config`)
    .then((r) => { _cache = r.data; _inflight = null; return _cache; })
    .catch((e) => { _inflight = null; throw e; });
  return _inflight;
}

export function useAgencyConfig() {
  const [data, setData] = useState(_cache);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (_cache) { setData(_cache); return; }
    let alive = true;
    _fetchOnce()
      .then((cfg) => { if (alive) setData(cfg); })
      .catch((e) => { if (alive) setError(e); });
    return () => { alive = false; };
  }, []);

  return { data, error, loading: !data && !error };
}

/** Helper: trova l'intermediario dato il codice ("christian_colucci" | "ciro_colucci"). */
export function findIntermediario(cfg, codice) {
  if (!cfg) return null;
  return (cfg.intermediari || []).find((i) => i.codice === codice) || null;
}
